module.exports = __webpack_public_path__ + "img/isometric.3414e66f.jpg";